import React from "react";
import "./Loader.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCompactDisc } from "@fortawesome/free-solid-svg-icons";

const Loader = () => {
  let random = Math.random() >= 0.5;
  return (
    <FontAwesomeIcon
      icon={faCompactDisc}
      className={random ? "loader cw" : "loader ccw"}
    />
  );
};
export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.jsx